import { IComponentOptions } from "angular";
import { SetupStep } from "@gtmhub/configuration/workday/models";

export class WizardProgressStepCtrl {
  currentStep: SetupStep;
  stepNo: number;
  translateKey: string;
  progressSteps = SetupStep;
}

export const WizardProgressStepComponent: IComponentOptions = {
  bindings: {
    stepNo: "<",
    currentStep: "<",
    translateKey: "<",
  },

  controller: WizardProgressStepCtrl,
  templateUrl: require("./progress-step.jade"),
  controllerAs: "$ctrl",
};
